<template>
    <div class="container-fluid pt-3">
        <div id="place-form" v-if="!user.global_admin">
            <h1>{{ t('places-access_denied') }}</h1>
        </div>
        <div id="place-form" v-if="user.global_admin">
            <div class="container-fluid">
                <h2>{{ t('places-plan-title', { 0: place.name }) }}</h2>
                <div id="plan-form" v-if="user.global_admin">
                    <div class="container-fluid" v-if="this.ready">
                        <div class="box row">
                            <div class="col-12 mb-3">
                                <select class="form-control" v-model="selectedPlan">
                                    <option
                                        v-for="(plan, index) in plans"
                                        :value="plan"
                                        :key="index"
                                    >
                                        {{ plan.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12">
                                <plan-form
                                    :selected-plan="selectedPlan"
                                    :current-values="currentPlanData"
                                    @change="onFormChange"
                                />
                            </div>

                            <div class="col-12 mt-3">
                                <div class="pull-right">
                                    <button
                                        class="btn btn-primary"
                                        @click.prevent="save"
                                    >
                                        {{ t('places-plan-save') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import { mapState } from "vuex";
import PlanForm from "./plan-form.vue";

export default {
    components: { PlanForm },
    props: {
        user: Object,
    },
    mounted: async function () {
        this.placeId = this.$route.params.id;
        this.$store.dispatch("placeDetails/setPlace", this.$route.params.id);
        await this.loadPlans();
        await this.loadCurrent();
        this.ready = true;
    },
    computed: mapState({
        place: (state) => state.placeDetails.placeDetails,
    }),
    data: function () {
        return {
            plans: [],
            placeId: this.$route.params.id,
            selectedPlan: null,
            ready: false,
            form: {},
            formSnapshot: null,
            currentPlanData: null,
        };
    },
    methods: {
        async loadPlans() {
            const response = await this.$http(keviApi.getOptions("plans", "GET"));
            this.plans = response.body.plans;
        },
        async loadCurrent() {
            try {
                const response = await this.$http(
                    keviApi.getOptions("place/" + this.placeId + "/plan", "GET")
                );
                if (response) {
                    this.currentPlanData = response.body.placePlan;
                    this.selectedPlan = this.plans.find(
                        (plan) => plan.id === response.body.placePlan.plans_id
                    );
                }
            } catch (error) {
                return;
            }
        },
        onFormChange(f) {
            this.form = f;
            if (!this.formSnapshot) {
                this.formSnapshot = JSON.parse(JSON.stringify(f));
            }
        },
        hasChanges() {
            if (!this.formSnapshot) return false;
            const s1 = { ...this.form, change_reason: null };
            const s2 = { ...this.formSnapshot, change_reason: null };
            return JSON.stringify(s1) !== JSON.stringify(s2);
        },
        save() {
            if (!this.hasChanges()) {
                this.$store.dispatch("notification/warning", {
                    text: this.t("places-plan-notification-no_changes"),
                    duration: 4000,
                });
                return;
            }

            if (
                this.form.billing_type === "postpaid" &&
                this.form.one_invoice_per_branch_plus_base &&
                !this.form.main_branch_id
            ) {
                this.$store.dispatch("notification/warning", {
                    text: this.t("plans-form-select_main_branch_warning"),
                    duration: 4000,
                });
                return;
            }

            if (!this.form.change_reason || !this.form.change_reason.trim()) {
                this.$store.dispatch("notification/warning", {
                    text: this.t("places-plan-notification-change_reason_required"),
                    duration: 4000,
                });
                return;
            }

            this.$http(
                keviApi.getOptions(
                    "place/" + this.placeId + "/plan",
                    "POST",
                    this.form
                )
            ).then(() => {
                this.formSnapshot = JSON.parse(JSON.stringify(this.form));
                this.$store.dispatch("placeDetails/loadBranches");
                this.$store.dispatch(
                    "notification/success",
                    this.t("places-plan-notification-saved")
                );
            });
        },
        t(term, replaces) {
            return this.$root.t ? this.$root.t(term, replaces) : term;
        },
    },
};
</script>
